
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { contact } from 'src/app/models/contact';
import { ApiService } from 'src/app/services/communications/api.service';
import { UserDataService } from 'src/app/services/userData.service';
import { SnackBarService } from '../../services/snackbar.service';
import { AddContactDialogComponent } from '../add-new-contact/add-new-contact.component';

@Component({
  selector: 'app-contacts-link-dialog',
  templateUrl: './contacts-link-dialog.component.html',
  styleUrls: ['./contacts-link-dialog.component.scss'],
  imports: [MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, TranslateModule, MatDialogModule, MatTooltipModule, MatSelectModule],
})

export class ContactsLinkDialogComponent implements OnInit {

  addButtons: boolean = false;
  assetId: number = 0;
  expertId: number;
  contacts: contact[] = [];
  errorMessage: string = "";
  selectedValue: string = "";
  selectedContact: contact | null = null;
  showSendSMS: boolean = false;
  showSendEmail: boolean = false;

  readonly dialogRef = inject(MatDialogRef<ContactsLinkDialogComponent>);
    dialog: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { assetId: number, expertId: number, addButtons: boolean }, private apiService: ApiService, private translate: TranslateService,
    private userDataService: UserDataService, private snackBarService: SnackBarService) {
    this.addButtons = data.addButtons;
    this.assetId = data.assetId;
    this.expertId = data.expertId;
  }

  ngOnInit() {
    this.loadContacts();
  }

  private loadContacts(): void {
    this.apiService.getContactsByClient(this.expertId).subscribe(data => {
      if (data.length > 0) {
        this.contacts = data;
        this.errorMessage = "";
        this.addButtons = true;
      } else {
        this.translate.get("CONTACTS.NO_CONTACTS").subscribe((text: string) => {
          this.errorMessage = text;
        });
        this.addButtons = false;
      }
    });
  }

  changeContact() {
    this.selectedContact = this.contacts.filter(c => c.Id == Number(this.selectedValue))[0];
    this.showSendEmail = this.selectedContact.Email.length > 0;
    this.showSendSMS = this.selectedContact.Phone.length > 0;
  }

  invite(emailMode: boolean) {
    let address = this.selectedContact?.Phone;
    if (emailMode) address = this.selectedContact?.Email;

    console.log(emailMode);

    this.apiService.sendInvitation(address!, emailMode, this.selectedContact!.Name, this.userDataService.AssetId!, this.selectedContact?.Id!, this.selectedContact?.UserRole!, this.userDataService?.AssistanceToOpen!).subscribe({
      next: (response) => {
        this.snackBarService.openSuccess(this.translate.instant('LINK_DIALOG.SEND_SUCCESS'));
      },
      error: (error) => {
        console.error('Error sending invitation:', error);
        this.snackBarService.openError(this.translate.instant('LINK_DIALOG.SEND_ERROR'));
      }
    });
  }

  addContact() {
    this.dialogRef.close("addContact");
  }
}
